import { generateId } from "../../../utils";

export const normalTextElement = { type: 'p', children: [{ text: '' }] }

export const getNormalTextElement = () => {
  return { type: 'p', uid: generateId(), attrs: {}, children: [{ text: '' }] }
}